"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGroupBy = useGroupBy;
const react_1 = require("react");
const useQueryState_1 = require("./useQueryState");
const index_1 = require("../utils/index");
function useGroupBy(opts) {
    const options = (0, react_1.useMemo)(() => (0, index_1.safeEntries)(opts).map(([key, value]) => ({ id: key, name: value })), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const [value, setValue] = (0, useQueryState_1.useQueryState)("groupBy", options[0].id);
    return { value, setValue, options };
}
